<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LazyRender',
  props: {
    maxTimeout: {
      type: Number,
      default: 7000,
    },
    forceShow: Boolean,
    viewExpand: {
      type: String,
      default: '150px',
    },
  },
  data() {
    return {
      isShow: this.forceShow,
      isVisible: false,
      watchEl: null,
    };
  },
  computed: {
    ...mapGetters('router', [
      'routeLoading',
    ]),
  },
  watch: {
    isShow: 'clear',
    forceShow(forceShow) {
      if (forceShow) this.isShow = true;
    },
    isVisible(isVisible) {
      if (isVisible) this.isShow = isVisible;
    },
  },
  mounted() {
    if (this.maxTimeout) {
      this.timeoutId = setTimeout(() => {
        this.isShow = true;
      }, this.maxTimeout);
    }
  },
  destroyed() {
    this.clearObserver();
  },
  methods: {
    setObserver() {
      if ('IntersectionObserver' in window) {
        if (!this.$refs.watchEl) return;
        // create observer object, set callback onIntersection and config
        this.observer = new IntersectionObserver(this.onIntersection, {
          // Expand viewport 50 px bottom to load image early
          rootMargin: `${this.viewExpand} 0px`,
          // request percent of image in viewport to load it
          threshold: 0.01,
        });
        // set observe image
        this.observer.observe(this.$refs.watchEl);
      } else {
        // if browser not support, preload immediate
        this.isVisible = true;
      }
    },
    onIntersection(entries) {
      // Loop through the entries
      entries.forEach((entry) => {
        // Are we in viewport?
        if (entry.intersectionRatio > 0) {
          // Stop watching and load the image
          if (this.observer) this.observer.disconnect();
          // clear observe object
          this.isVisible = true;
        }
      });
    },
    clear(isShow) {
      if (isShow) {
        this.clearObserver();
        this.$emit('render');
        if (this.timeoutId) clearTimeout(this.timeoutId);
      }
    },
    clearObserver() {
      if (this.observer) {
        this.observer.disconnect();
        delete this.observer;
      }
    },
  },
  render(createElement) {
    if (this.routeLoading) return null;
    if (!this.isShow) {
      const watchEl = createElement('div', {
        class: { 'watch-element': true },
        ref: 'watchEl',
      });
      this.$nextTick(this.setObserver);
      return watchEl;
    }
    return (this.$slots.default && this.$slots.default[0]) || null;
  },
};
</script>
